import React, { useState, useEffect } from "react";
import numeral from "numeral";
import {
    Row, Col,
    Label, FormGroup, Button,
    Modal, ModalHeader, ModalBody, ModalFooter,
} from "reactstrap";
import CustomTextInput from "../../../../components/CustomTextInput";
import ApiCaller from "../../../../api/apiCaller";

interface RentalInformationTabProps {
    siteId:number;
    isView?: boolean;
    isShow?: boolean;
    onSaveCallback?: Function;
    onCancelCallback?: Function;
}

export default function SiteInBuildingRentalCalculationModal({
    siteId,
    isView,
    isShow,
    onSaveCallback,
    onCancelCallback,
}: RentalInformationTabProps) {
    const [currentUser, setCurrentUser] = useState<any>({});
    const [showModal, setIsShow] = useState<boolean>(isShow || false);
    const [dataManipulationMode, setDataManipulationMode] = useState<string>('create');
    const [rentalCalculationData, setRentalCalculationData] = useState<any>({
        site_id: siteId,
        site: {
            id: siteId,
        },
        indoor_rental_price_per_sqm: 0,
        indoor_service_fee_per_sqm: 0,
        indoor_area_sqm: 0,
        outdoor_rental_price_per_sqm: 0,
        outdoor_service_fee_per_sqm: 0,
        outdoor_area_sqm: 0,
    });
    const toogleModal = () => {
        setIsShow(!showModal);
    }

    const getCurrentUser = async () => {
        const res = await ApiCaller.get('userme/me');
        if (res.result) {
          setCurrentUser(res.result);
        }
    }

    const getCalculationResult = async () => {
        const uri = `site_in_building_rental_calculation/${siteId}`;
        const res = await ApiCaller.get(uri);
        if (res?.result) {
            setDataManipulationMode('update');
            setRentalCalculationData({
                ...rentalCalculationData,
                ...res.result,
            });
        } else {
            setDataManipulationMode('create');
        }
    }

    const updateAttr = (attribute: string, value: any) => {
        const dataUpdate:any = {};
        dataUpdate[attribute] = value;

        setRentalCalculationData({
          ...rentalCalculationData,
          ...dataUpdate,
        });
    };

    const saveCalculationResult = async () => {
        const dataToSubmit = {
            ...rentalCalculationData,
            changed_by: {
                id: currentUser.id,
            },
        };
        
        let res = null;
        if (dataManipulationMode === 'create') {
            const uri = `site_in_building_rental_calculation/`;
            dataToSubmit.created_by = { id: currentUser.id };
            res = await ApiCaller.post(uri, dataToSubmit);
        } else {
            const uri = `site_in_building_rental_calculation/${siteId}`;
            res = await ApiCaller.put(uri, dataToSubmit);
        }
        if (res?.result) {
            console.log(res.result);
            if (onSaveCallback) {
                onSaveCallback(res?.result);
            }
            toogleModal();
        } else {
            console.log(res.result);
        }
    }

    const cancelModal = () => {
        toogleModal();
        if (onCancelCallback) {
            onCancelCallback();
        }
    }

    useEffect(() => {
        getCalculationResult();
        getCurrentUser();
    }, []);

    useEffect(() => {
        setIsShow(isShow || false);
    }, [isShow]);

    // Calculate pricing
    const indoorRentalPrice = (parseFloat(rentalCalculationData.indoor_rental_price_per_sqm) + parseFloat(rentalCalculationData.indoor_service_fee_per_sqm)) * parseFloat(rentalCalculationData.indoor_area_sqm);
    const outdoorRentalPrice = (parseFloat(rentalCalculationData.outdoor_rental_price_per_sqm) + parseFloat(rentalCalculationData.outdoor_service_fee_per_sqm)) * parseFloat(rentalCalculationData.outdoor_area_sqm);
    const siteTotalRentalFee = indoorRentalPrice + outdoorRentalPrice;
    const siteTotalArea = parseFloat(rentalCalculationData.indoor_area_sqm) + parseFloat(rentalCalculationData.outdoor_area_sqm);

    return (
        <Modal size="lg" isOpen={showModal} toggle={toogleModal}>
            <ModalHeader toggle={toogleModal}>Tính tiền thuê mặt bằng trong tòa nhà</ModalHeader>
            <ModalBody>
                <Row>
                    <Col xs={12} style={styles.sectionTitle}>
                        <span>Khu vực trong nhà</span>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={4}>
                        <CustomTextInput
                            labelText="Giá thuê (VND/m2)"
                            data={rentalCalculationData}
                            attributeName="indoor_rental_price_per_sqm"
                            isNumeric
                            type="text"
                            callback={updateAttr}
                            disabled={isView}
                        />
                    </Col>
                    <Col xs={12} sm={4}>
                        <CustomTextInput
                            labelText="Phí dịch vụ (VND/m2)"
                            data={rentalCalculationData}
                            attributeName="indoor_service_fee_per_sqm"
                            isNumeric
                            type="text"
                            callback={updateAttr}
                            disabled={isView}
                        />
                    </Col>
                    <Col xs={12} sm={4}>
                        <CustomTextInput
                            labelText="Diện tích trong nhà (m2)"
                            data={rentalCalculationData}
                            attributeName="indoor_area_sqm"
                            isNumeric
                            isDecimal
                            type="text"
                            callback={updateAttr}
                            disabled={isView}
                        />
                    </Col>
                    <Col xs={12}>
                        <div style={styles.totalPriceLabel}>
                            Giá thuê trong nhà:
                            <span style={styles.totalPrice}>{numeral(indoorRentalPrice).format("0,0")} VND</span>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} style={styles.sectionTitle}>
                        <span>Khu vực ngoài trời</span>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={4}>
                        <CustomTextInput
                            labelText="Giá thuê (VND/m2)"
                            data={rentalCalculationData}
                            attributeName="outdoor_rental_price_per_sqm"
                            isNumeric
                            type="text"
                            callback={updateAttr}
                            disabled={isView}
                        />
                    </Col>
                    <Col xs={12} sm={4}>
                        <CustomTextInput
                            labelText="Phí dịch vụ (VND/m2)"
                            data={rentalCalculationData}
                            attributeName="outdoor_service_fee_per_sqm"
                            isNumeric
                            type="text"
                            callback={updateAttr}
                            disabled={isView}
                        />
                    </Col>
                    <Col xs={12} sm={4}>
                        <CustomTextInput
                            labelText="Diện tích ngoài trời (m2)"
                            data={rentalCalculationData}
                            attributeName="outdoor_area_sqm"
                            isNumeric
                            isDecimal
                            type="text"
                            callback={updateAttr}
                            disabled={isView}
                        />
                    </Col>
                    <Col xs={12}>
                        <div style={styles.totalPriceLabel}>
                            Giá thuê trong nhà:
                            <span style={styles.totalPrice}>{numeral(outdoorRentalPrice).format("0,0")} VND</span>
                        </div>
                    </Col>
                </Row>
                <Row style={styles.summarySection}>
                    <Col xs={12} style={styles.totalPriceAfterCalculationLabel}>
                        <span>
                            Tổng diện tích:
                            <span style={styles.totalPriceAfterCalculation}>{numeral(siteTotalArea).format("0,0")} m2</span>
                        </span>
                    </Col>
                    <Col xs={12} style={styles.totalPriceAfterCalculationLabel}>
                        <span>
                            Tổng giá thuê:
                            <span style={styles.totalPriceAfterCalculation}>{numeral(siteTotalRentalFee).format("0,0")} VND</span>
                        </span>
                    </Col>
                </Row>
            </ModalBody>
        {!isView ?
            <ModalFooter>
                <Button color="secondary" onClick={cancelModal}>Hủy</Button>
                <Button color="primary" onClick={saveCalculationResult}>Lưu</Button>{' '}
            </ModalFooter>
            :
            <ModalFooter>
                <Button color="secondary" onClick={cancelModal}>Quay lại</Button>
            </ModalFooter>
        }
        </Modal>
    );
}

const styles = {
    sectionTitle: {
        marginTop: 12,
        marginLeft: 12,
        marginBottom: 12,
        paddingLeft: 12,
        paddingTop: 6,
        paddingBottom: 6,
        color: 'var(--color-accent-dark)',
        borderLeft: '2px solid var(--color-accent-dark)',
        fontSize: 18,
        fontWeight: 500,
    },
    totalPriceLabel: {
        color: 'var(--color-muted)',
        fontSize: 18,
        display: 'flex',
        justifyContent: 'flex-end',
    },
    totalPrice: {
        fontWeight: 500,
        marginLeft: 6,
    },
    summarySection: {
        marginTop: 12,
    },
    totalPriceAfterCalculationLabel: {
        fontSize: 18,
        marginTop: 12,
        display: 'flex',
        justifyContent: 'flex-end',
    },
    totalPriceAfterCalculation: {
        marginLeft: 6,
        fontWeight: 500,
    }
};
